// Espelha AuthService.saveFotoPessoaLogada/getFotoPessoaLogada: mesma chave e
// mesmo encoding (JSON.stringify puro, sem base64), para que o cache escrito
// por um lado seja lido pelo outro.
const PHOTO_CACHE_KEY = 'foto_pessoa';

/** Lê sessionStorage['foto_pessoa']; null se ausente/ilegível. */
export function getPhotoCache(): string | null {
  try {
    const raw = sessionStorage.getItem(PHOTO_CACHE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as string | null;
  } catch {
    return null;
  }
}

/** Grava sessionStorage['foto_pessoa'] (foto já prefixada ou null). */
export function savePhotoCache(photo: string | null): void {
  try {
    sessionStorage.setItem(PHOTO_CACHE_KEY, JSON.stringify(photo));
  } catch {
    // Storage indisponível (modo privado, quota, etc.) — cache é best-effort.
  }
}
